import {EntityData, field, identifier, LocalisableEntityData, transientField} from "@fedeltapointofsale/data-client";
import {Directive} from "@angular/core";

@Directive()
export abstract class AbstractBIPageData<T> extends LocalisableEntityData<T> {
    @identifier id: number;
    @field name: string;
    @field cubeName: string;
    @field public: boolean;
    @field dateRangeRef: string;
}

/**
 * This class is intended for use on the bi-page search page.
 */
export class BIPageData extends EntityData<BIPageData> {
    public static readonly PAGE_TYPE_DASHBOARD = "Dashboard";
    public static readonly PAGE_TYPE_PIVOT_GRID = "PivotGrid";

    @field pageType: string;
    @identifier id: number;
    @field cubeName: string;
    @field name: string;
    @field recUserId: number;
    @field userName: string;

    @transientField get owner(): string | number {
        return this.id < 0 ? "System"
            : this.recUserId ? this.userName
                : "Public";
    }
}
